import { render, staticRenderFns } from "./OrgFilter.vue?vue&type=template&id=4e968b96&"
import script from "./OrgFilter.vue?vue&type=script&lang=js&"
export * from "./OrgFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports